<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <mdb-card-body class="d-sm-flex justify-content-between">
    <div class="md-form col-sm-12 col-md-1 col-lg-1 px-1" style="margin-top: 5px">
      <input
        [(ngModel)]="userTradingSearchRequest.searchTerm"
        mdbInput
        name="searchTerm"
        type="text"
        (keyup.enter)="SearchPossibleUserTrades()"
        id="searchTerm"
        class="form-control"
        style="height: 19px"
        #searchTerm="ngModel"
        required
      />
      <label for="searchTerm">Search</label>
    </div>
    <div class="md-form col-sm-12 col-md-1 col-lg-2 ml-2 px-1" style="margin-top: 5px">
      <input
        [(ngModel)]="userTradingSearchRequest.minBalance"
        mdbInput
        name="minBalance"
        type="number"
        id="minBalance"
        class="form-control"
        style="height: 19px"
        #minBalance="ngModel"
        required
        (keyup.enter)="SearchPossibleUserTrades()"
      />
      <label for="minBalance">Min Trade Amount (ZAR)</label>
    </div>
    <div class="md-form col-sm-12 col-md-1 col-lg-2 px-1" style="margin-top: 5px">
      <select
        class="md-form form-control browser-default w-100"
        id="balDate"
        [(ngModel)]="userTradingSearchRequest.accountBalanceDate"
        placeholder="Account balance date"
      >
        <option *ngFor="let balDate of usersAccountBalanceDates; trackBy: trackById" [ngValue]="balDate.Name">
          {{ balDate.Name }}
        </option>
      </select>
      <label for="balDate" class="active">Account balance date</label>
    </div>
    <div class="md-form col-sm-12 col-md-1 col-lg-2 px-1" style="margin-top: 5px">
      <select
        id="resultOrderingSelect"
        class="md-form form-control browser-default w-100"
        [(ngModel)]="userTradingSearchRequest.orderBy"
        placeholder="Order Results by"
      >
        <option *ngFor="let orderBy of usersOrderBy; trackBy: trackById" [ngValue]="orderBy.Name">
          {{ orderBy.Name }}
        </option>
      </select>
      <label for="resultOrderingSelect" class="active">Order Results by</label>
    </div>
    <div class="md-form col-sm-12 col-md-1 col-lg-1 px-1" style="margin-top: 5px">
      <select
        id="showExcludedUsersSelect"
        class="md-form form-control browser-default w-100"
        [(ngModel)]="userTradingSearchRequest.showExcludedUsers"
        placeholder="Show excluded users"
      >
        <option *ngFor="let showExcluded of showExcludedUsersOptions; trackBy: trackById" [ngValue]="showExcluded.Value">
          {{ showExcluded.Name }}
        </option>
      </select>
      <label for="showExcludedUsersSelect" class="active">Show excluded users</label>
    </div>
    <div class="md-form col-sm-12 col-md-1 col-lg-2 px-1" style="margin-top: 5px">
      <select id="tradeFilterSelect" class="md-form form-control browser-default w-100" [(ngModel)]="userTradingSearchRequest.tradeFilter">
        <option *ngFor="let filter of tradeFilter; trackBy: trackById" [ngValue]="filter.name">
          {{ filter.name }}
        </option>
      </select>
      <label for="tradeFilterSelect" class="active">Filter Trades</label>
    </div>
    <div class="md-form col-sm-12 col-md-2 col-lg-1 px-1 text-right">
      <button mdbBtn size="sm" class="my-0 p btn-trakly-action" (click)="SearchPossibleUserTrades()">Search</button>
    </div>
  </mdb-card-body>
</mdb-card>

<mdb-card cascade="true" narrower="true" class="mt-3">
  <!--Card image-->
  <div
    id="max-trade-sticky"
    class="sticky-top view view-cascade gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center row"
  >
    <div class="col-sm-12 col-md-3 col-lg-3">
      <p class="white-text mx-3 my-auto">Possible Trades</p>
      <p class="white-text mx-3 my-auto" *ngIf="tradesToProcess.length >= 1 && isBelowBookingLimit()">
        {{ tradesToProcess.length }} selected
      </p>
      <p class="mx-3 my-auto" *ngIf="isBelowBookingLimit() == false"><mdb-badge color="red">Booking Limit Reached</mdb-badge></p>
    </div>

    <div class="col-sm-12 col-md-3 col-lg-3" *ngIf="tradesToProcess.length > 0">
      <p class="white-text mx-3 my-auto">
        Total value of selected trades: R
        {{ totalTradesValue | number: "1.0-2" }}
      </p>
    </div>
    <div class="col-sm-12 col-md-3 col-lg-3" *ngIf="tradesToProcess.length == 0">
      <p class="white-text mx-3 my-auto">Total value of selected trades: R 0</p>
    </div>
    <div class="col-sm-12 col-md-3 col-lg-3">
      <p class="white-text mx-3 my-auto" *ngIf="!arbFacilitatorAvailableBalance">Max trade value: R -</p>
      <p class="white-text mx-3 my-auto" *ngIf="arbFacilitatorAvailableBalanceRemaining">
        Max trade value: R
        {{ arbFacilitatorAvailableBalanceRemaining | number: "1.0-2" }}
      </p>
    </div>
    <div class="col-sm-12 col-md-3 col-lg-3">
      <button
        type="button"
        mdbBtn
        color="white"
        outline="true"
        rounded="true"
        size="sm"
        class="px-2"
        mdbWavesEffect
        (click)="Extract('PossibleTrades')"
      >
        <mdb-icon fas icon="cloud-download-alt" class="mt-0"></mdb-icon> Extract
      </button>
      <button mdbBtn size="sm" class="my-0 p btn-trakly-action" (click)="DisplayCFSCheckDialog()">CFS Client Check</button>
    </div>
  </div>
  <!--/Card image-->

  <div class="px-4">
    <div class="col">
      <div *ngIf="showError && !busy" class="alert alert-danger text-center font-weight-bold" role="alert">
        {{ errorMsg }}
      </div>
      <div
        class="alert alert-info text-center"
        role="alert"
        *ngIf="savedTradesSuccessful.length != 0 || savedTradesInvalid.length != 0 || savedTradesFailed.length != 0"
      >
        Please refresh the table before continuing<button
          mdbBtn
          size="sm"
          class="my-0 p btn-trakly-action"
          (click)="SearchPossibleUserTrades()"
        >
          Refresh
        </button>
      </div>
    </div>
    <div *ngIf="!busy">
      <div class="md-form col-sm-12 col-md-1 col-lg-2 px-1" style="margin-top: 5px">
        <select
          class="md-form form-control browser-default w-100"
          id="tagFilter"
          placeholder="Filter Tags"
          [(ngModel)]="selectedTagFilterId"
          (change)="filterByTagId()"
        >
          <option *ngFor="let tag of tagFilter; trackBy: trackById" [ngValue]="tag.id">
            {{ tag.name }}
          </option>
        </select>
        <label for="tagFilter" class="active">Tag Filter</label>
      </div>
      <!--Table-->
      <table class="table" mdbTable hover="true" small="true" id="possibleTrades">
        <thead class="sticky-table-header">
          <tr>
            <th scope="col"></th>
            <th scope="col" class="text-left">Full Name</th>
            <th scope="col" class="text-left" style="width: 100px">Suggested Trade</th>
            <th scope="col" class="text-left">
              Account Balance <br /><small class="text-black-50">({{ this.latestBankBalanceDate | date: "dd MMM HH:mm" }})</small>
            </th>
            <th scope="col" class="text-left">SDA Available</th>
            <th scope="col" class="text-left">FIA Available</th>
            <th scope="col" class="text-left">AIT Pin Balance</th>
            <th scope="col" class="text-center">Possible Trades</th>
            <th scope="col" class="text-left">Last Trade</th>
          </tr>
        </thead>
        <tbody>
          <tr
            mdbTableCol
            *ngFor="let user of userTradingSearchResponse; trackBy: trackById"
            [ngClass]="{
              TableRowSelected: user.selected,
              'table-info': !user.canTrade,
              'grey-highlight': user.plan == 'Standard'
            }"
          >
            <td class="text-center" scope="row">
              <div class="btn-group">
                <mdb-checkbox
                  [(ngModel)]="user.selected"
                  [default]="false"
                  class="mt-2"
                  *ngIf="user.canTrade"
                  (click)="onTradeCheckboxChanged(user)"
                >
                </mdb-checkbox>

                <button
                  *ngIf="user.selected && user.canTrade"
                  mdbBtn
                  type="button"
                  color="trakly"
                  size="md"
                  mdbWavesEffect
                  (click)="onTradeEditClicked(user)"
                >
                  Edit
                </button>
                <button
                  type="button"
                  *ngIf="!user.canTrade"
                  mdbBtn
                  size="sm"
                  color="danger"
                  rounded="true"
                  mdbWavesEffect
                  mdbPopover="{{ user.tradeReasonDetail }}"
                  placement="top"
                  mdbPopoverHeader="{{ user.tradeReason }}"
                  triggers="hover"
                >
                  {{ user.tradeReason }}
                </button>
              </div>
            </td>
            <td class="text-left" (click)="ShowModal(user, 'userInfoModal')">
              <span class="clickable">
                {{ user.userDetails.fullName }}
              </span>
              <div style="margin-top: 10px; font-size: smaller; display: flex; justify-content: space-between">
                <span class="text-left"></span>
                <span class="text-right" style="max-width: 150px">
                  <app-tags [Tags]="user.tags" [ExcludedTagIds]="[TagId.AIT_NOTES]" (TagError)="parseAndDisplayError($event)"> </app-tags>
                  <span *ngIf="user.hasPinInReview">&nbsp;<mdb-badge color="grey" mdbTooltip="Pin in Review">R</mdb-badge></span>
                </span>
              </div>
              <div class="small" style="margin-top: 10px; color: red" *ngIf="user.warnings.length > 0">
                <div *ngFor="let warning of filteredWarnings(user.warnings); trackBy: trackById">
                  {{ warning.title }}
                </div>
              </div>
              <div *ngIf="user.profileIsLoading" class="progress" style="height: 5px; margin-top: 5px">
                <div
                  class="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  aria-valuenow="75"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 100%"
                ></div>
              </div>
            </td>
            <td class="text-left">
              <span>{{ user.suggestedTradeAmount | number: "1.0-2" }}</span>
            </td>
            <td class="text-left" *ngIf="!user.overrideAccountBalance">
              {{ user.accountBalance | number: "1.0-0" }}
              <span *ngIf="user.displaySpouseFigures" class="text-muted"><br />{{ user.spouseAccountBalance | number: "1.0-0" }}</span>
            </td>
            <td class="text-left" *ngIf="user.overrideAccountBalance">
              {{ user.overriddenAccountBalance | number: "1.0-0" }}
              <mdb-badge color="red" *ngIf="user.overrideAccountBalance">Overridden</mdb-badge>
              <span *ngIf="user.displaySpouseFigures" class="text-muted"><br />{{ user.spouseAccountBalance | number: "1.0-0" }}</span>
            </td>
            <td class="text-left">
              {{ user.sdaAvailable | number: "1.0-0" }}
              <span *ngIf="user.displaySpouseFigures" class="text-muted"><br />{{ user.spouseSdaAvailable | number: "1.0-0" }}</span>
            </td>
            <td class="text-left lemon-highlight">
              {{ user.fiaAvailable | number: "1.0-0" }}
              <span *ngIf="user.displaySpouseFigures" class="text-muted"><br />{{ user.spouseFiaAvailable | number: "1.0-0" }}</span>
            </td>
            <td class="text-left" *ngIf="user.userFiaPins.length > 0">
              {{ user.userFiaPinsAvailableAmount | number: "1.0-0" }}
              <span *ngIf="user.displaySpouseFigures && user.spousePinCount > 0" class="text-muted"
                ><br />{{ user.spousePinsAvailableAmount | number: "1.0-0" }}
              </span>
              <span *ngIf="user.displaySpouseFigures && user.spousePinCount == 0"><br /><mdb-badge color="grey">No Pins</mdb-badge></span>
            </td>
            <td class="text-left" *ngIf="user.userFiaPins.length == 0">
              <mdb-badge color="red">No Pins</mdb-badge>
              <span *ngIf="user.displaySpouseFigures && user.spousePinCount > 0" class="text-muted"
                ><br />{{ user.spousePinsAvailableAmount | number: "1.0-0" }}
              </span>
              <span *ngIf="user.displaySpouseFigures && user.spousePinCount == 0"><br /><mdb-badge color="grey">No Pins</mdb-badge></span>
            </td>
            <td class="text-center">
              {{ user.suggestedTradeSdaFiaRatio }}
            </td>
            <td class="text-left" *ngIf="user.lastTransactionDate != null">
              {{ user.lastTransactionDate | date }}
            </td>
            <td class="text-left" *ngIf="user.lastTransactionDate == null">No trade history</td>
          </tr>
        </tbody>
      </table>
      <!--Table-->
    </div>
  </div>
  <!--Save btn-->
  <div class="float-right ml-auto mr-2" id="settingsSaveBtn" *ngIf="!busy">
    <button
      type="button"
      mdbBtn
      color="trakly-action"
      block="true"
      class="my-4 w-auto"
      type="submit"
      *ngIf="
        tradesToProcess.length > 0 &&
        savedTradesSuccessful.length == 0 &&
        savedTradesInvalid.length == 0 &&
        savedTradesFailed.length == 0 &&
        isBelowBookingLimit()
      "
      (click)="ProcessSelectedTrades()"
    >
      Process Selected
    </button>
  </div>
  <!--Loading-->
  <div class="col-12 text-center" *ngIf="busy">
    <div *ngIf="busy" class="spinner-grow text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</mdb-card>

<div
  mdbModal
  #userFiaPinModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  [config]="{ ignoreBackdropClick: true, keyboard: false }"
  style="overflow-y: auto"
  aria-labelledby="User Fia Pins"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fluid" role="document">
    <div class="modal-content">
      <div class="modal-header" *ngIf="selectedTrade.userDetails">
        <button type="button" class="close pull-right" aria-label="Close" *ngIf="isEditMode() == false" (click)="onTradeCloseClick()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100 font-weight-bold" id="myModalLabel">{{ selectedTrade.userDetails.fullName }} - Editing Trade</h4>
      </div>
      <div class="modal-body" *ngIf="selectedTrade.userDetails">
        <row>
          <div class="d-block col-12 text-center">
            <p class="font-weight-bold mb-1">User Details</p>
          </div>
          <table mdbTable hover="false" small="true">
            <thead>
              <tr>
                <th scope="col" class="text-left" style="width: 13%">Account Balance</th>
                <th scope="col" class="text-left" style="width: 8%"></th>
                <th scope="col" class="text-left" style="width: 12%">Max Trade</th>
                <th scope="col" class="text-left" style="width: 10%">Pips</th>
                <th scope="col" class="text-left" style="width: 8%"></th>
                <th scope="col" class="text-left" style="width: 13%">SDA Available</th>
                <th scope="col" class="text-left" style="width: 13%">AIT Available</th>
                <th scope="col" class="text-left" style="width: 13%">Suggested Trade</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol>
                <td class="text-left" *ngIf="!selectedTrade.overrideAccountBalance">
                  R {{ selectedTrade.accountBalance | number: "1.0-0" }}
                </td>
                <td class="text-left" *ngIf="selectedTrade.overrideAccountBalance">
                  <div class="md-form my-0">
                    <input
                      mdbInput
                      mdbValidate
                      type="number"
                      id="overriddenAccountBalance"
                      name="overriddenAccountBalance"
                      class="form-control py-0 mt-2"
                      [(ngModel)]="selectedTrade.overriddenAccountBalance"
                      (change)="ValidateTradeBreakdown(selectedTrade)"
                    />
                  </div>
                </td>
                <td class="text-left" *ngIf="!selectedTrade.overrideAccountBalance">
                  <button (click)="OverrideAccBalance()" mdbBtn class="mx-0" type="button" color="trakly" size="sm" mdbWavesEffect>
                    Override
                  </button>
                </td>
                <td class="text-left" *ngIf="selectedTrade.overrideAccountBalance"></td>

                <td class="text-left">R {{ selectedTrade.maxTradeAmount | number: "1.0-0" }}</td>

                <td class="text-left" *ngIf="selectedTrade.overridePips == false">
                  {{ selectedTrade.pips | number: "1.0-0" }}
                </td>
                <td class="text-left" *ngIf="selectedTrade.overridePips == false">
                  <button mdbBtn class="mx-0" type="button" color="trakly" size="sm" mdbWavesEffect (click)="OverridePips()">
                    Override
                  </button>
                </td>

                <td class="text-left" *ngIf="selectedTrade.overridePips == true">
                  <input
                    mdbInput
                    mdbValidate
                    type="number"
                    id="pips"
                    name="pips"
                    class="form-control py-0 mt-2"
                    [(ngModel)]="selectedTrade.pips"
                    (change)="ValidateTradeBreakdown(selectedTrade)"
                  />
                </td>
                <td class="text-left" *ngIf="selectedTrade.overridePips == true">heh heh</td>

                <td class="text-left" *ngIf="selectedTrade.overrideAccountBalance"></td>
                <td class="text-left">R {{ selectedTrade.sdaAvailable | number: "1.0-0" }}</td>
                <td class="text-left">R {{ selectedTrade.fiaAvailable | number: "1.0-0" }}</td>
                <td class="text-left">R {{ selectedTrade.suggestedTradeAmount | number: "1.0-2" }}</td>
              </tr>
            </tbody>
          </table>
          <div class="alert alert-danger text-center" role="alert" *ngIf="selectedTrade.overrideAccountBalance">
            This users account balance has been overridden. Please ensure that the funds reflect in the users account and to include SWIFT
            fees
            <b>before</b> booking this trade.
          </div>
          <hr />
          <div class="d-block col-12 text-center">
            <p class="font-weight-bold mb-1">Trade Breakdown</p>
          </div>
          <table mdbTable hover="true" small="true">
            <thead>
              <tr>
                <th scope="col" class="col-1 text-left">Pin</th>
                <th scope="col" class="col-2 text-left">Issue Date</th>
                <th scope="col" class="col-2 text-left">Expiry Date</th>
                <th scope="col" class="col-2 text-left">Pin Amount</th>
                <th scope="col" class="col-2 text-left">Pin Balance</th>
                <th scope="col" class="col-1 text-right"></th>
                <th scope="col" class="col-2 text-left">Amounts Used</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let pin of selectedTrade.userFiaPins; trackBy: trackById">
                <td class="text-left">{{ pin.pin }}</td>
                <td class="text-left">{{ pin.pinIssueDate | date }}</td>
                <td class="text-left">{{ pin.pinExpiryDate | date }}</td>
                <td class="text-left">R {{ pin.pinAmount | number: "1.0-2" }}</td>
                <td class="text-left">R {{ pin.pinBalance | number: "1.0-2" }}</td>
                <td class="text-right">
                  <button
                    *ngIf="pin.transactionUsedAmount == 0 && selectedTradeAmountRemaining > 0 && selectedTrade.fiaAvailable > 0"
                    (click)="fillPin(pin, selectedTrade.fiaAvailable)"
                    mdbBtn
                    class="mx-0"
                    type="button"
                    color="trakly-action"
                    size="sm"
                    mdbWavesEffect
                  >
                    Fill
                  </button>
                  <button
                    *ngIf="pin.transactionUsedAmount != 0"
                    (click)="clearPin(pin)"
                    mdbBtn
                    class="mx-0"
                    type="button"
                    color="trakly"
                    size="sm"
                    mdbWavesEffect
                  >
                    Clear
                  </button>
                </td>
                <td class="text-left">
                  <div class="md-form my-0">
                    <input
                      mdbInput
                      mdbValidate
                      type="number"
                      id="transactionUsedAmount"
                      name="transactionUsedAmount"
                      class="form-control py-0 mt-2"
                      [(ngModel)]="pin.transactionUsedAmount"
                      (change)="updateTotals()"
                    />
                  </div>
                </td>
              </tr>
              <tr mdbTableRow *ngIf="selectedTrade.userFiaPins.length == 0">
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left">
                  <mdb-badge color="red">No Pins</mdb-badge>
                </td>
              </tr>
              <tr mdbTableCol>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-right font-weight-bold align-middle">SDA Amount:</td>
                <td class="text-right font-weight-bold">
                  <button
                    *ngIf="selectedTrade.sdaAmount == 0 && selectedTradeAmountRemaining > 0"
                    (click)="fillSdaAmount()"
                    mdbBtn
                    class="mx-0"
                    type="button"
                    color="trakly-action"
                    size="sm"
                    mdbWavesEffect
                  >
                    Fill
                  </button>
                  <button
                    *ngIf="selectedTrade.sdaAmount != 0"
                    (click)="clearSda()"
                    mdbBtn
                    class="mx-0"
                    type="button"
                    color="trakly"
                    size="sm"
                    mdbWavesEffect
                  >
                    Clear
                  </button>
                </td>
                <td class="text-left">
                  <div class="md-form my-0">
                    <input
                      mdbInput
                      mdbValidate
                      type="number"
                      id="transactionSdaAmount"
                      name="transactionSdaAmount"
                      class="form-control py-0 mt-2"
                      [(ngModel)]="selectedTrade.sdaAmount"
                      (change)="updateTotals()"
                    />
                  </div>
                </td>
              </tr>
              <tr mdbTableCol>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-right font-weight-bold">Difference from Suggested Trade Amount</td>
                <td class="text-left font-weight-bold">R {{ selectedTradeAmountRemaining | number: "1.0-2" }}</td>
              </tr>
              <tr mdbTableCol>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td
                  class="text-right font-weight-bold"
                  [ngClass]="{
                    'red-highlight': doesCurrentTradeDeviateFromLastTrade(10000)
                  }"
                >
                  Trade Total
                </td>
                <td
                  class="text-left font-weight-bold"
                  [ngClass]="{
                    'red-highlight': doesCurrentTradeDeviateFromLastTrade(10000)
                  }"
                >
                  {{ selectedTradeTotalAmount | currency: "ZAR" : "symbol-narrow" }}
                </td>
              </tr>
              <tr mdbTableCol>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-right font-weight-bold grey-highlight">Last Trade</td>
                <td class="text-left font-weight-bold grey-highlight">
                  {{ selectedTrade.lastTransactionAmount | currency: "ZAR" : "symbol-narrow" }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="alert alert-danger text-center" role="alert" *ngIf="showValidationMessage">
            {{ validationMessage }}
          </div>
        </row>

        <div class="modal-footer">
          <div style="padding-right: 15px" *ngIf="selectedTrade.clientNotes?.length > 0">
            <div class="card" style="width: 500px">
              <div class="card-header alert-info">
                <h5>Client Notes</h5>
              </div>
              <div class="card-body">
                <p class="card-text">{{ selectedTrade.clientNotes }}</p>
              </div>
            </div>
          </div>
          <div *ngIf="hasWarnings()" style="margin-top: 10px">
            <app-checklist
              Title="Warnings"
              [CheckListItems]="selectedTrade.warnings"
              InstructionText="Please acknowledge all warnings to continue."
              (allChecked)="allWarningsAcknowledged()"
              (notAllChecked)="notAllWarningsAcknowledged()"
            ></app-checklist>
          </div>
          <div>
            <button type="button" mdbBtn color="trakly-action" class="waves-light" (click)="onTradeSaveClick()" *ngIf="allowedToSave()">
              Save
            </button>
            <button type="button" mdbBtn color="trakly" class="waves-light" *ngIf="isEditMode() == false" (click)="onTradeCloseClick()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  id="cfsChecksModal"
  #cfsCheckClients="mdbModal"
  style="overflow-y: auto"
  [config]="{ ignoreBackdropClick: true, keyboard: false }"
  class="modal"
  tabindex="-3"
  role="dialog"
  aria-labelledby="CFS Checking Clients"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 font-weight-bold">CFS Client Check</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="this.showCFSCheckError" class="alert alert-danger text-center font-weight-bold" role="alert">
          {{ this.cfsChecksErrorMessage }}
        </div>
        <app-loading [busy]="this.busyWithCFSChecks" [busyText]="'Sending to Dooya'"></app-loading>
        <div *ngIf="showCFSReadyStep()">
          <p>
            This will send all the ID Numbers of clients loaded in the Trade Planning page to Dooya for checking with CFS for KYC and
            Deposits.
          </p>
        </div>
        <div *ngIf="showCFSCodeStep()">
          <p>ID Numbers have been successfully sent, now please provide the security code sent to your phone.</p>
          <div *ngIf="this.showSendCodeButton" class="md-form">
            <input
              mdbInput
              mdbValidate
              name="cfsCheckCode"
              type="text"
              id="cfsCheckCode"
              class="form-control"
              [(ngModel)]="this.CFSCode"
              required
            />
            <label for="cfsCheckCode">Enter Security Code:</label>
          </div>
        </div>
        <div *ngIf="showCFSCompleteStep()">
          <p>
            Dooya will now process, please monitor Telegram for a notification once completed. Refreshing the page will then include the
            results.
          </p>
        </div>
        <div *ngIf="this.cfsCheckCompletedDate != null">
          <p>
            Latest Request: <strong>{{ this.cfsCheckCompletedDate | date: "d MMM H:mm a" }}</strong>
          </p>
        </div>
      </div>
      <div class="modal-footer justify-content-right">
        <button *ngIf="showCFSReadyStep()" mdbBtn type="button" color="trakly-action" (click)="SendClientIDs()">Send to Dooya</button>
        <button *ngIf="showCFSCodeStep()" mdbBtn type="button" color="trakly-action" (click)="SubmitCFSCode()">Submit Code</button>
        <button type="button" mdbBtn color="grey" class="waves-light" (click)="cfsCheckClients.hide()">Close</button>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  id="bookTradesModal"
  #bookTradesResponseModal="mdbModal"
  style="overflow-y: auto"
  [config]="{ ignoreBackdropClick: false, keyboard: false, animation: false }"
  class="modal"
  tabindex="-2"
  role="dialog"
  aria-labelledby="Current Trades"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fluid" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="bookTradesResponseModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100 font-weight-bold" id="tradeResponseModalHeader">Prebooking Results</h4>
      </div>
      <div class="modal-body">
        <div class="col-12 text-center" *ngIf="busy">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Prebooking trades ... please wait for a response</span>
          </div>
        </div>

        <row *ngIf="savedTradesFailed.length > 0">
          <div class="alert alert-danger text-center font-weight-bold" role="alert">
            Failed Trades ({{ savedTradesFailed.length }}): Note the reasons below
          </div>
          <table mdbTable hover="false" small="true">
            <thead>
              <tr>
                <th scope="col" class="col-1 text-left">Full Name</th>
                <th scope="col" class="col-1 text-left">Trade Amount</th>
                <th scope="col" class="col-1 text-left">SDA Amount</th>
                <th scope="col" class="col-1 text-left">FIA Amount</th>
                <th scope="col" class="col-2 text-left">Pins</th>
                <th scope="col" class="col-4 text-left">Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let failed of savedTradesFailed">
                <td class="text-left">{{ failed.trade.fullName }}</td>
                <td class="text-left">R {{ failed.trade.tradeAmount | number: "1.0-0" }}</td>
                <td class="text-left">R {{ failed.trade.sdaAmount | number: "1.0-0" }}</td>
                <td class="text-left">R {{ failed.trade.fiaAmount | number: "1.0-2" }}</td>
                <td class="text-left">{{ failed.trade.pinsAsText }}</td>
                <td class="text-left text-danger" *ngIf="failed.trade.shouldShowBadge">
                  <mdb-badge color="danger">CAUTION</mdb-badge>{{ failed.trade.strippedCautionMessage }}
                </td>
                <td class="text-left text-danger" *ngIf="!failed.trade.shouldShowBadge">{{ failed.trade.message }}</td>
              </tr>
            </tbody>
          </table>
        </row>

        <row *ngIf="savedTradesInvalid.length > 0">
          <div class="alert alert-danger text-center font-weight-bold" role="alert">
            Invalid Trades ({{ savedTradesInvalid.length }}): These trades didn't pass validation
          </div>
          <table mdbTable hover="false" small="true">
            <thead>
              <tr>
                <th scope="col" class="col-1 text-left">Full Name</th>
                <th scope="col" class="col-1 text-left">Trade Amount</th>
                <th scope="col" class="col-1 text-left">SDA Amount</th>
                <th scope="col" class="col-1 text-left">FIA Amount</th>
                <th scope="col" class="col-2 text-left">Pins</th>
                <th scope="col" class="col-4 text-left">Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let invalid of savedTradesInvalid">
                <td class="text-left">{{ invalid.trade.fullName }}</td>
                <td class="text-left">R {{ invalid.trade.tradeAmount | number: "1.0-0" }}</td>
                <td class="text-left">R {{ invalid.trade.sdaAmount | number: "1.0-0" }}</td>
                <td class="text-left">R {{ invalid.trade.fiaAmount | number: "1.0-2" }}</td>
                <td class="text-left">{{ invalid.trade.pinsAsText }}</td>
                <td class="text-left text-danger">
                  <div *ngIf="invalid.trade.message">{{ invalid.trade.message }}</div>
                  <div *ngIf="invalid.validationMessage">{{ invalid.validationMessage }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </row>

        <row *ngIf="savedTradesSuccessful.length > 0">
          <div class="alert alert-success text-center font-weight-bold" role="alert">
            Saved ({{ savedTradesSuccessful.length }}): These trades were successfully saved on Trakly and will begin to be booked on Dooya.
            <i>Please monitor Current Trades page.</i>
          </div>
          <table mdbTable hover="false" small="true">
            <thead>
              <tr>
                <th scope="col" class="col-2 text-left">Full Name</th>
                <th scope="col" class="col-1 text-left">Trade Amount</th>
                <th scope="col" class="col-1 text-left">SDA Amount</th>
                <th scope="col" class="col-1 text-left">FIA Amount</th>
                <th scope="col" class="col-3 text-left">Pins</th>
                <th scope="col" class="col-1 text-left">Message</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let success of savedTradesSuccessful">
                <td class="text-left">{{ success.trade.fullName }}</td>
                <td class="text-left">R {{ success.trade.tradeAmount | number: "1.0-0" }}</td>
                <td class="text-left">R {{ success.trade.sdaAmount | number: "1.0-0" }}</td>
                <td class="text-left">R {{ success.trade.fiaAmount | number: "1.0-0" }}</td>
                <td class="text-left">
                  <span *ngFor="let pin of success.trade.userFiaPins"
                    ><strong>{{ pin.pin }}</strong> : R {{ pin.transactionUsedAmount | number: "1.0-0" }}
                  </span>
                </td>
                <td class="text-left">{{ success.trade.message }}</td>
              </tr>
            </tbody>
          </table>
        </row>
      </div>

      <div class="modal-footer justify-content-right">
        <button type="button" mdbBtn color="trakly" class="relative waves-light" (click)="bookTradesResponseModal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>

<app-user-profile-modal [selectedUserDetails]="selectedUserFullDetails" [(showModal)]="showUserProfileModal"></app-user-profile-modal>

<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
